import { HIGHEST_LOSER, HIGHEST_LOSER_STREAM, } from "../../../interface/drivingMarket/HighestLosers/highestLoser";
import { drivingMarketOptionsStream } from "@domains/features/Markets/Options/utils/streamUpdate";
let initState = {
    data: {},
};
const HighestLoser = (state = initState, action) => {
    switch (action.type) {
        case HIGHEST_LOSER:
            return Object.assign(Object.assign({}, state), { data: action.payload.data });
        case HIGHEST_LOSER_STREAM:
            return Object.assign(Object.assign({}, state), { data: drivingMarketOptionsStream(state.data, action.payload.qouteStream) });
        default:
            return state;
    }
};
export default HighestLoser;
